import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';

import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "container-centered small"
  }, [_c("div", {
    attrs: {
      id: "wine-list-global-container"
    }
  }, [_c("TargetSelectors", {
    attrs: {
      loggedUserData: _vm.loggedUserData
    },
    on: {
      changeThirdPartyUserSelected: _vm.search,
      changePricePostingSelected: _vm.search
    }
  }), _c("div", {
    staticClass: "search-global-container"
  }, [_c("div", {
    staticClass: "search-main-line"
  }, [_c("div", {
    staticClass: "search-main-text-field"
  }, [_c(VTextField, {
    attrs: {
      solo: "",
      "hide-details": "auto",
      clearable: "",
      placeholder: "Search for a label, producer ...",
      "append-icon": "fa-search",
      loading: _vm.loadingSearch
    },
    on: {
      "click:append": _vm.advancedSearch,
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.advancedSearch.apply(null, arguments);
      },
      "click:clear": function clickClear() {
        _vm.searchCriterias.label = null;
        _vm.search(true);
      }
    },
    model: {
      value: _vm.searchCriterias.label,
      callback: function callback($$v) {
        _vm.$set(_vm.searchCriterias, "label", $$v);
      },
      expression: "searchCriterias.label"
    }
  })], 1), _c("div", {
    staticClass: "search-pagination-limit"
  }, [_c(VSelect, {
    staticClass: "paging-limits-select",
    attrs: {
      solo: "",
      "hide-details": "auto",
      items: _vm.pagingLimitsChoices
    },
    on: {
      change: function change($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.searchCriterias.paging.limits,
      callback: function callback($$v) {
        _vm.$set(_vm.searchCriterias.paging, "limits", $$v);
      },
      expression: "searchCriterias.paging.limits"
    }
  })], 1)]), _c("div", {
    staticClass: "search-table-top"
  }, [_c("div", {
    staticClass: "search-pagination-index"
  }, [_c("index", {
    attrs: {
      currentPage: _vm.searchCriterias.paging.currentPage,
      limits: Number(_vm.searchCriterias.paging.limits),
      totalNumber: _vm.baseModel.numberOfWines
    }
  })], 1)])]), _c("div", {
    attrs: {
      id: "wine-list-wrapper"
    }
  }, [_vm.baseModel.wines.length == 0 && !_vm.loadingSearch ? _c("div", {
    staticClass: "list-empty"
  }, [_vm._v(" No products available. ")]) : _c("div", {
    staticClass: "wine-list"
  }, [_vm.loadingSearch ? _c("div", {
    staticClass: "text-left mb-15"
  }, [_c(VProgressCircular, {
    attrs: {
      indeterminate: "",
      size: "45",
      width: "3"
    }
  })], 1) : _vm._l(_vm.baseModel.wines, function (wine) {
    return _c("wine-card", {
      key: "".concat(wine.id_wine, "_").concat(wine.customerPriceEuro),
      attrs: {
        wineProp: wine,
        isAddingToCart: _vm.isAddingToCart,
        loggedUserData: _vm.loggedUserData
      },
      on: {
        changeQuantityOrder: _vm.changeQuantityOrder,
        addItemToCart: _vm.addItemToCart
      }
    });
  })], 2), _vm.hasResult ? _c("div", {
    staticClass: "table-bottom-container"
  }, [_c("div", {
    staticClass: "table-bottom-pagination-paging"
  }, [_c("paging", {
    attrs: {
      numberOfPages: _vm.baseModel.numberOfPages,
      currentPage: _vm.searchCriterias.paging.currentPage
    },
    on: {
      changePage: _vm.changePage
    }
  })], 1), _c("div", {
    staticClass: "table-bottom-right"
  }, [_c("div", {
    staticClass: "table-bottom-pagination-limit"
  }, [_c(VSelect, {
    staticClass: "paging-limits-select",
    attrs: {
      items: _vm.pagingLimitsChoices,
      solo: "",
      "hide-details": "auto"
    },
    on: {
      change: function change($event) {
        return _vm.search();
      }
    },
    model: {
      value: _vm.searchCriterias.paging.limits,
      callback: function callback($$v) {
        _vm.$set(_vm.searchCriterias.paging, "limits", $$v);
      },
      expression: "searchCriterias.paging.limits"
    }
  })], 1), _c("div", {
    staticClass: "table-bottom-pagination-index"
  }, [_c("index", {
    attrs: {
      currentPage: _vm.searchCriterias.paging.currentPage,
      limits: Number(_vm.searchCriterias.paging.limits),
      totalNumber: _vm.baseModel.numberOfWines
    }
  })], 1)])]) : _vm._e()]), _vm.isAdminNotConsultant(_vm.loggedUserData) ? _c("WineStockListModal", {
    key: _vm.wineStockKey,
    ref: "WineStockListModal",
    attrs: {
      wine: _vm.currentWine,
      quantity: _vm.currentQuantity,
      casingId: _vm.casingIdSelected,
      add: _vm.addItemToCart,
      isBasket: true
    },
    on: {
      closed: _vm.closeWineStockListModal
    }
  }) : _vm._e(), _c("confirm", {
    ref: "confirm"
  }), _c("ErrorModal", {
    ref: _vm.ERROR_DATA.ref
  })], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };